import React, { useEffect, useState } from "react";
import KanbanBoardContainer from "../utilities/KanbanBoardContainer";
import { fetchMembers } from "../../store/actions/adminActions";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Button, Table } from "react-bootstrap";

function SummaryReport() {
  const { members } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(fetchMembers());
  }, [dispatch]);

  useEffect(() => {
    if (members) {
      const memberswithrequest = members.filter((member) => {
        const { initialSavingsRequest } = member;
        return initialSavingsRequest?.acknowledged === "seen";
      });

      let processedData = memberswithrequest.map((member, index) => {
        const flattenedMember = flattenObj(member);
        return {
          ...flattenedMember,
          serial: index + 1,
          time: moment(member.initialSavingsRequest.requestedAt).format(
            "dddd, MMMM Do YYYY, h:mm:ss a"
          )
        };
      });

      setData(processedData);
    }
  }, [members]);

  const flattenObj = (obj) => {
    let result = {};
    for (const i in obj) {
      if (typeof obj[i] === "object" && !Array.isArray(obj[i]) && obj[i] !== null) {
        const temp = flattenObj(obj[i]);
        for (const j in temp) {
          result[j] = temp[j];
        }
      } else {
        result[i] = obj[i];
      }
    }
    return result;
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortedData = () => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  };

  const columns = [
    { dataField: "serial", text: "#", width: "50px" },
    { dataField: "name", text: "Name", width: "200px", sortable: true },
    { dataField: "ippisNum", text: "IPPIS number", width: "200px" },
    { dataField: "staffNum", text: "Staff Number", width: "200px" },
    { dataField: "memberId", text: "Member Id", width: "200px" },
    { dataField: "shareCapitalAmount", text: "Share Capital Amount", width: "200px" },
    { dataField: "shareCapitalMonths", text: "Share capital months", width: "200px" },
    { dataField: "ordinarySavingsAmount", text: "Ordinary savings amount", width: "200px" },
    { dataField: "ordinarySavingsMonths", text: "Ordinary savings months", width: "200px" },
    { dataField: "christmasSavingsAmount", text: "Christmas savings amount", width: "200px" },
    { dataField: "christmasSavingsMonths", text: "Christmas savings months", width: "200px" },
    { dataField: "educationSavingsAmount", text: "Education savings amount", width: "200px" },
    { dataField: "educationSavingsMonths", text: "Education savings months", width: "200px" },
    { dataField: "retirementSavingsAmount", text: "Retirement savings amount", width: "200px" },
    { dataField: "retirementSavingsMonths", text: "Retirement savings months", width: "200px" },
    { dataField: "landDevSavingsAmount", text: "Land Development savings amount", width: "200px" },
    { dataField: "landDevSavingsMonths", text: "Land Development Savings months", width: "200px" },
    { dataField: "time", text: "Submitted On", width: "200px", sortable: true }
  ];

  const exportToCSV = () => {
    const csvContent = [
      columns.map(col => col.text), // Header row
      ...getSortedData().map(row => columns.map(col => row[col.dataField] || ''))
    ].map(row => row.join(','));

    const blob = new Blob([csvContent.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', 'members_summary.csv');
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <KanbanBoardContainer>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">
            MEMBERS SUMMARY TABLE
          </h3>
        </div>
        <section className="content pb-3">
          <div className="card-body">
            <div style={{ textAlign: "right", marginBottom: "15px" }}>
              <Button variant="primary" size="lg" onClick={exportToCSV}>
                Export To CSV
              </Button>
            </div>
            <hr />
            <div className="table-responsive">
              <Table striped hover>
                <thead>
                  <tr>
                    {columns.map(column => (
                      <th
                        key={column.dataField}
                        style={{
                          backgroundColor: "#c8e6c9",
                          width: column.width,
                          cursor: column.sortable ? 'pointer' : 'default'
                        }}
                        onClick={() => column.sortable ? requestSort(column.dataField) : null}
                      >
                        {column.text}
                        {sortConfig.key === column.dataField && (
                          <span className="ms-1">
                            {sortConfig.direction === 'ascending' ? '▲' : '▼'}
                          </span>
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {getSortedData().map((row) => (
                    <tr key={row._id}>
                      {columns.map(column => (
                        <td key={`${row._id}-${column.dataField}`}>
                          {row[column.dataField]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </section>
      </div>
    </KanbanBoardContainer>
  );
}

export default SummaryReport;